import React, { ComponentProps } from 'react';

import PropTypes from 'prop-types';

import Button from '@adsk/alloy-react-button';
import { CalendarIcon, RenderIconType } from '@adsk/alloy-react-icon';

import Field from './Field';
import { DATE_PICKER_VARIANTS } from '../consts';
import { Variant } from '../types';

type TriggerProps = ComponentProps<typeof Field> & {
  variant?: Variant;
};

const renderIcon: RenderIconType = (p) => <CalendarIcon {...p} />;

const Trigger = ({ variant, value, ...rest }: TriggerProps) => {
  if (variant === DATE_PICKER_VARIANTS.ICON) {
    return <Button renderIcon={renderIcon} {...rest} />;
  }

  return <Field value={value} {...rest} />;
};

Trigger.displayName = 'DatePickerTrigger';

Trigger.propTypes = {
  /** Variant of the field could be icon or field */
  variant: PropTypes.oneOf(Object.values(DATE_PICKER_VARIANTS)),
};

export default Trigger;
